import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M0 12a3.25 3.25 0 1 0 6.5 0A3.25 3.25 0 1 0 0 12m8.75 0a3.25 3.25 0 1 0 6.5 0 3.25 3.25 0 1 0-6.5 0m8.75 0a3.25 3.25 0 1 0 6.5 0 3.25 3.25 0 1 0-6.5 0"
    }, null, -1)
  ]));
}
const interfaceDotsHorizontal = { render };
export {
  interfaceDotsHorizontal as default,
  render
};
//# sourceMappingURL=interface-dots-horizontal.svg.js.map
